import type { JSX } from 'react'

export const DolbyAtmosIcon = (): JSX.Element => (
  <use href='#dolbyAtmosIcon' height='100%' width='100%' />
)
